import React, { useEffect, useState, Children } from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, ShieldAlert, LayoutGrid, Gift, Clock } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
function BonusCountdown() {
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('bonus-timer-end') : null;
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      return remaining;
    }
    const endTime = Date.now() + 30 * 60 * 1000;
    if (typeof window !== 'undefined') sessionStorage.setItem('bonus-timer-end', endTime.toString());
    return 30 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-3" data-id="element-1">
      <div className="flex items-center gap-2" data-id="element-2">
        <Clock className="w-5 h-5 text-accent" data-id="element-3" />
        <span className="font-heading font-bold text-text-primary text-sm" data-id="element-4">
          Bonus gratis por:
        </span>
      </div>
      <div className="flex items-center gap-1" data-id="element-5">
        <span className="bg-bg border border-accent/30 rounded-md px-3 py-1.5 font-heading font-black text-accent text-xl tabular-nums min-w-[3rem] text-center" data-id="element-6">
          {String(minutes).padStart(2, '0')}
        </span>
        <span className="text-accent font-bold text-xl" data-id="element-7">:</span>
        <span className="bg-bg border border-accent/30 rounded-md px-3 py-1.5 font-heading font-black text-accent text-xl tabular-nums min-w-[3rem] text-center" data-id="element-8">
          {String(seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}
export function BonusSection() {
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const staggerContainer = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const bonuses = [{
    num: '1',
    icon: <MessageSquare className="w-8 h-8" data-id="element-9" />,
    title: 'Comandos Invisibles en WhatsApp',
    desc: 'Cómo influir y cerrar acuerdos por texto. La psicología de los tiempos de respuesta, el uso estratégico del silencio y estructuras de mensajes que obligan a responder.',
    highlight: true,
    image: 'https://cdn.magicpatterns.com/uploads/9Th7NvCNC327DK5J7jQV4w/heylloyd-image-1772482026692.png'
  }, {
    num: '2',
    icon: <ShieldAlert className="w-8 h-8" data-id="element-10" />,
    title: 'Desmontando al Manipulador',
    desc: 'Identificá y anulá a quienes intenten usar tácticas oscuras contra vos. Un escudo táctico para entornos corporativos tóxicos y negociaciones hostiles.',
    highlight: false,
    image: 'https://cdn.magicpatterns.com/uploads/vJPe1jMfcsL3YgvJTZjsF2/heylloyd-image-1772482695549.png'
  }, {
    num: '3',
    icon: <LayoutGrid className="w-8 h-8" data-id="element-11" />,
    title: 'El Tablero de Influencia Diaria',
    desc: 'Tu hoja de ruta estratégica para cada interacción clave. Un framework visual para planificar reuniones importantes antes de que sucedan.',
    highlight: false,
    image: 'https://cdn.magicpatterns.com/uploads/fhmwvkAU7h1qksHUwJct86/heylloyd-image-1772482682144.png'
  }];
  return <SectionWrapper className="bg-surface border-y border-border" data-id="element-12">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={staggerContainer} data-id="element-13">
        <div className="text-center mb-6" data-id="element-14">
          <motion.h2 variants={fadeUp} className="font-heading text-3xl md:text-5xl font-black text-text-primary uppercase tracking-tight" data-id="element-15">
            Bonus Exclusivos
          </motion.h2>
        </div>

        <motion.div variants={fadeUp} className="text-center mb-10" data-id="element-16">
          <div className="inline-flex items-center gap-2 bg-accent/10 border border-accent/20 rounded-full px-5 py-2 mb-6" data-id="element-17">
            <Gift className="w-4 h-4 text-accent" data-id="element-18" />
            <span className="font-heading font-bold text-accent text-sm uppercase tracking-wider" data-id="element-19">
              Gratis hoy con tu compra
            </span>
          </div>
          <div className="mt-2" data-id="element-20">
            <BonusCountdown data-id="element-21" />
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-22">
          {bonuses.map((bonus, idx) => <motion.div key={idx} variants={fadeUp} className={`relative bg-bg border p-8 rounded-xl transition-all duration-300 hover:-translate-y-1 flex flex-col ${bonus.highlight ? 'border-accent/50 shadow-[0_0_30px_rgba(0,255,136,0.1)]' : 'border-border hover:border-accent/30'}`} data-id="element-23">
              <div className="absolute -top-3 right-4" data-id="element-24">
                <span className="bg-accent text-bg font-heading font-bold text-[10px] uppercase tracking-widest px-3 py-1 rounded-full" data-id="element-25">
                  Gratis
                </span>
              </div>

              <div className="flex justify-center mb-6" data-id="element-26">
                <img src={bonus.image} alt={bonus.title} className="w-36 h-auto rounded-lg shadow-lg" data-id="element-27" />
              </div>

              <div className="mb-4" data-id="element-28">
                <span className="text-accent font-heading font-bold text-xs tracking-widest uppercase mb-2 block" data-id="element-29">
                  Bonus #{bonus.num}
                </span>
                <h3 className="font-heading font-bold text-xl text-text-primary leading-tight" data-id="element-30">
                  {bonus.title}
                </h3>
              </div>

              <p className="font-body text-sm text-text-secondary leading-relaxed" data-id="element-31">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </motion.div>
    </SectionWrapper>;
}